module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAThJREFUWEftlm0OwjAIhuFkupPpTqaeDPMuZcGGjrZps5isv3Q6eHj5KtPJh0/2TxfA/yggIk8iuqWauRPRm4g++M7M+K3rhAqICJy9AutrL8QhQIr6YZwjahxEDjUAtx9mDgPKAym+kDmHY0SpALud/H/MvLTk4ghA1FAUWQbRlA4XoMegiKBOtuJsUSEEiKJXlSx07TtbB3n5EhGVv1rOrFsWr148XxFAtZyjAZrzOToFmGza/1Vyjgaw0y9MQ0/X7C1eGhq1RvNR3dIBxS4wraW1oI/W9EEnItJkx3FxYpYCDWe3sw88W7oZtW6q2zcEgDezin+WTyLZnDlbswqiCsCGnBzhDhAtJrwWQjQDRJvOSdkhxHAAkzJ7jyhCTAFogZgG4EC4KkwFMBDFi+t0gKhoL4BLgS8la6ohFR7NLQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/fangdajing.png
// module id = 9zFo
// module chunks = 1